import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'tun-remote-icon',
    templateUrl: './remote-icon.component.html',
    styleUrls: ['./remote-icon.component.scss'],
    standalone: false
})
export class RemoteIconComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
